export const excludedDataKeys: string[] = ['customerID', 'supplierID'];

export const MAX_LENGTH_DESKTOP = 40;
export const MAX_LENGTH_TABLET = 45;
export const MAX_LENGTH_PHONE = 50;
